export enum SiteDirection {
    rightToLeft = "right",
    leftToRight = "left"
}